import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.invitePayload"],
  payload => payload
);
